// src/config/constants.js

// ============ File / Upload ============
export const FILE_CONFIG = {
  maxSize: Number(import.meta.env.VITE_MAX_FILE_SIZE) || 5 * 1024 * 1024, // 5 MB
  supportedFormats: (import.meta.env.VITE_SUPPORTED_FORMATS || '.pdf,.doc,.docx,.txt')
    .split(',')
    .map(s => s.trim().toLowerCase())
    .filter(Boolean),
};

// ============ Claude / Proxy ============
export const CLAUDE_CONFIG = {
  baseURL:
    import.meta.env.VITE_CLAUDE_PROXY_URL ||
    'https://smart-resume-proxy-2.davidmadison95.workers.dev',
  model: import.meta.env.VITE_CLAUDE_MODEL || 'claude-3-haiku-20240307',
  maxTokens: Number(import.meta.env.VITE_CLAUDE_MAX_TOKENS) || 4096,
  temperature: Number(import.meta.env.VITE_CLAUDE_TEMPERATURE) || 0.3,
  // Not used when proxying (left here for local/direct debugging only)
  apiKey: import.meta.env.VITE_CLAUDE_API_KEY || '',
};

// ============ App / Feature Flags ============
export const APP_CONFIG = {
  name: import.meta.env.VITE_APP_NAME || 'SmartResumeTool',
  version: import.meta.env.VITE_APP_VERSION || '2.0.0',
  environment: import.meta.env.VITE_ENVIRONMENT || 'production',
  url: import.meta.env.VITE_APP_URL || 'https://davidmadison95.github.io/smart-resume-tool',
};

export const FEATURE_FLAGS = {
  enableAISuggestions: import.meta.env.VITE_ENABLE_AI_SUGGESTIONS === 'true',
  enableExport: import.meta.env.VITE_ENABLE_EXPORT === 'true',
  enableAnalytics: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
};

// ============ Errors ============
export const ERROR_MESSAGES = {
  API_ERROR: 'AI analysis is unavailable. Using traditional analysis instead.',
  NETWORK_ERROR: 'Network connection failed. Please try again.',
  FILE_READ_ERROR: 'Unable to read the uploaded file.',
  FILE_TYPE_NOT_ALLOWED: 'Unsupported file type.',
  PARSE_ERROR: 'Unable to extract text from the file.',
};

// ============ Keyword / ATS Analysis ============
export const ANALYSIS_CONFIG = {
  maxKeywords: 150,
  stopWords: new Set([
    'the','and','for','with','from','that','this','you','your','are','was','were',
    'have','has','had','a','an','to','of','in','on','as','by','at','it','be','or'
  ]),
};

export const SCORING_WEIGHTS = {
  KEYWORD_MATCH: 40,
  ATS_FORMAT: 25,
  CONTENT_STRUCTURE: 20,
  CONTACT_INFO: 10,
  MEASURABLE_RESULTS: 5,
};
